'use es6';

import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
const DAY_IN_MS = 1000 * 60 * 60 * 24;
export function isTimestampLessThanOneDayAgo(messageTimestamp) {
  return I18n.moment().diff(messageTimestamp) < DAY_IN_MS;
}
export function isFutureTimestamp(messageTimestamp) {
  return messageTimestamp.diff(I18n.moment()) > 0;
}
export function isTimestampThisYear(messageTimestamp) {
  return messageTimestamp.get('year') === I18n.moment().get('year');
}
export function getDateFormatWithYear(messageTimestamp) {
  const format = 'MMM Do YYYY, h:mm A';
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    value: messageTimestamp,
    format: format,
    type: "userTz"
  });
}
getDateFormatWithYear.displayName = 'getDateFormatWithYear';
export function getDateFormatWithoutYear(messageTimestamp) {
  const format = 'MMM Do, h:mm A';
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    value: messageTimestamp,
    format: format,
    type: "userTz"
  });
}
getDateFormatWithoutYear.displayName = 'getDateFormatWithoutYear';
export function getTimeAgoDate(messageTimestamp) {
  if (isFutureTimestamp(messageTimestamp)) {
    return I18n.moment().fromNow();
  }
  return messageTimestamp.fromNow();
}
export function getDateString(messageTimestamp) {
  if (isTimestampLessThanOneDayAgo(messageTimestamp)) {
    return getTimeAgoDate(messageTimestamp);
  }
  if (isTimestampThisYear(messageTimestamp)) {
    return getDateFormatWithoutYear(messageTimestamp);
  }
  return getDateFormatWithYear(messageTimestamp);
}